import React from "react";
import ManagerCounterPresenter from "./ManagerCounterPresenter";
import NavBar from "../../../../components/navigation";
import CardView from "../../../../components/common/CardView";
import { Calendar, Badge } from "antd";
import {
  countObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import { updateSchemaUseCase } from "../../../../usecases/schema/usecases";
import BaseListPage from "../../../../base/BaseListPage";
import { Button } from "nq-component";
import withRouter from "../../../../withRouter";

class ManagerCounter extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ManagerCounterPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      updateSchemaUseCase(),
    );
    this.state = {
      objects: [],
      selected: [],
      progress: true,
      count: 0,
      holiday: [],
      approvedLeave: [],
      enrolledTraining: [],
      suspension: [],
      activeEmployee: [],
      employeeOnLeave: 0,
      tasks: 0,
      where: {},
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "dashboard";
  }

  // Event data for each date
  getListData(value) {
    let listData = [];
    const year = value.year();
    const month = value.month(); // 0-indexed, January is 0
    const day = value.date();

    // Process holidays
    if (this.state.holiday.length > 0) {
      this.state.holiday.forEach((item) => {
        const holidayDate = new Date(item?.date);

        // Match year, month, and date for holiday
        if (
          holidayDate.getFullYear() === year &&
          holidayDate.getMonth() === month &&
          holidayDate.getDate() === day
        ) {
          listData.push({
            type: "warning", // You can change type based on item details if needed
            content: item?.type || "Holiday Event", // or a default content
            name: `${item?.name}` || "",
          });
        }
      });
    }

    // suspension
    if (this.state.suspension.length > 0) {
      this.state.suspension.forEach((item) => {
        const dateFrom = new Date(item?.from);
        const dateTo = new Date(item?.to);
        // const hasSuspension =
        //   dateFrom <= value.toDate() && dateTo >= value.toDate();
        // console.log("TEST: ", hasSuspension);

        // Get the date parts without the time component
        const dateFromOnly = new Date(dateFrom.setHours(0, 0, 0, 0)); // Set the time to midnight
        const dateToOnly = new Date(dateTo.setHours(0, 0, 0, 0)); // Set the time to midnight
        const valueDateOnly = new Date(value.toDate().setHours(0, 0, 0, 0)); // Set the value date to midnight

        if (dateFromOnly <= valueDateOnly && dateToOnly >= valueDateOnly) {
          listData.push({
            type: "success", // Customize type if needed
            content: (
              <div
                onClick={() => this.navigateTo("/suspension")}
                style={{ whiteSpace: "nowrap", overflow: "hidden" }}
              >
                {`${item?.type}` || "Work Suspension"}
              </div>
            ),
          });
        }
      });
    }

    // Process approved leaves
    if (this.state.approvedLeave.length > 0) {
      this.state.approvedLeave.forEach((item) => {
        const startDate = new Date(item?.startdate);
        const endDate = new Date(item?.enddate);

        // Check if the current date is within the leave period
        if (startDate <= value.toDate() && endDate >= value.toDate()) {
          listData.push({
            type: "success", // Customize type if needed
            content: (
              <div
                onClick={() => this.navigateTo("/lmanagement")}
                style={{ whiteSpace: "nowrap", overflow: "hidden" }}
              >
                {`${item?.selectedType || ""} ${item?.selectedLeave || ""}` ||
                  "Approved Leave"}
              </div>
            ),
          });
        }
      });
    }

    // process enrolled
    if (this.state.enrolledTraining.length > 0) {
      this.state.enrolledTraining.forEach((item) => {
        const startDate = new Date(item?.datefrom);
        const endDate = new Date(item?.dateto);

        // Check if the current date is within the leave period
        if (startDate <= value.toDate() && endDate >= value.toDate()) {
          listData.push({
            type: "success", // Customize type if needed
            content: (
              <div
                onClick={() => this.navigateTo("/training")}
                style={{ whiteSpace: "nowrap", overflow: "hidden" }}
              >
                {item?.training}
              </div>
            ),
            name: `${item?.email}` || "Email",
          });
        }
      });
    }

    return listData;
  }

  cellRender(value) {
    const listData = this.getListData(value);

    return (
      <ul
        className="events"
        style={{ listStyle: "none", padding: 0, margin: 0 }}
      >
        {listData.map((item, index) => (
          <li key={index} style={{ marginBottom: "5px" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Badge status={item?.type} />
              <div style={{ marginLeft: "8px" }}>
                {/* Check if content is a JSX element */}
                {React.isValidElement(item?.content) ? (
                  item?.content
                ) : (
                  <>
                    <span>{item?.name}</span>
                    <br />
                    <span>{item?.content}</span>
                  </>
                )}
              </div>
            </div>
          </li>
        ))}
      </ul>
    );
  }

  render() {
    return (
      <>
        <div className="row d-flex flex-grow-1 justify-content-center w-100 h-100 p-0">
          <div className="col-lg-4 mb-2" style={{ height: "270px" }}>
            <CardView>
              <p className="text-primary fw-bold">Employees On-Leave</p>
              <h1 className="align-self-center fw-bold text-primary">
                {this.state.employeeOnLeave}
              </h1>
            </CardView>
          </div>
          <div className="col-lg-4">
            <CardView>
              <p className="text-primary fw-bold">Tasks</p>
              <h1 className="align-self-center fw-bold text-primary">
                {this.state.tasks}
              </h1>
            </CardView>
          </div>
          {/* <div className="col-lg-4 w-50">
                <CardView>
                  <p className="text-primary fw-bold">Employees Active</p>
                  <h1 className="align-self-center fw-bold text-primary">
                    {this.state.activeEmployee.length}
                  </h1>
                </CardView>
              </div> */}
          <div className="col-lg-4">
            <CardView>
              <p className="text-primary fw-bold">Holidays / Events</p>
              <h1 className="align-self-center fw-bold text-primary">
                {this.state.holiday.length}
              </h1>
            </CardView>
          </div>

          {/* Calendar Component */}
          <div className="col-lg-12 pt-3">
            <div className="d-flex justify-content-center align-items-center fs-5 h-100">
              <Calendar
                style={{
                  width: "100%",
                  maxWidth: "1500px",
                  padding: "10px",
                  borderRadius: "10px",
                }}
                cellRender={this.cellRender.bind(this)}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ManagerCounter);
